<template>
  <!-- Leaderboard Section -->
  <section
    id="leaderboards"
    class="h-full overflow-hidden leaderboard-bg relative bg-gradient-to-r from-[#737DD8] via-[#737DD8] to-[#737DD8]"
  >
    <img
      src="../assets/circle.png"
      alt="Circle 5"
      class="absolute top-[380px] right-[140px] w-[320px] h-[320px] rounded-full object-contain"
    />
    <img
      src="../assets/circle.png"
      alt="Circle 6"
      class="absolute bottom-[740px] right-[20px] w-[220px] h-[220px] rounded-full object-contain z-40"
    />
    <img
      src="../assets/circle.png"
      alt="Circle 7"
      class="absolute bottom-[240px] -left-[60px] w-[220px] h-[220px] rounded-full object-contain z-40"
    />
    <img
      src="../assets/circle.png"
      alt="Circle 8"
      class="absolute bottom-[20px] right-[120px] w-[320px] h-[320px] rounded-full object-contain z-40"
    />
    <img
      src="../assets/circle.png"
      alt="Circle 9"
      class="absolute md:hidden bottom-[1120px] left-[400px] w-[220px] h-[220px] rounded-full object-contain z-40"
    />
    <div
      class="absolute md:hidden z-10 -top-[200px] -left-[140px] w-full h-[800px] md:w-[400px] md:h-[400px] rounded-full bg-[#F25960] opacity-10 blur-2xl"
    ></div>
    <div
      class="absolute md:hidden z-10 md:z-40 -top-[200px] -right-[140px] w-full h-[800px] md:w-[400px] md:h-[400px] rounded-full bg-[#F25960] opacity-10 blur-2xl"
    ></div>

    <!-- <div class="absolute bg-black bg-opacity-30 top-0 left-0 w-full h-full max-h-[1024px] z-[2]"></div> -->
    <!-- <img src="../assets/leaderboard-bg.png"
      class="absolute flex -top-[40px] md:top-0 left-0 w-full h-full object-cover object-left-bottom lg:object-contain 2xl:object-cover md:object-center max-h-[1224px] z-[1]" /> -->
    <div class="flex items-center justify-center w-full px-4 md:px-0 lg:pt-0">
      <div
        class="w-full flex flex-col justify-center items-center my-8 md:my-10 md:mt-[120px] md:p-4 rounded-3xl z-10"
      >
        <div
          class="text-[#96FF82] text-3xl md:text-7xl lg:text-4xl text-center leading-[48px] font-black"
          style="
            font-family: Montserrat, sans-serif;
            text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
          "
        >
          ${{ animatedTotalPrize.toLocaleString() }}
          <span class="text-white">STAKE LEADERBOARD</span>
        </div>

        <div class="flex flex-col items-center justify-center my-10 lg:mt-8 lg:mb-5">
          <div class="bg-transparent">
            <div
              v-motion-slide-visible-bottom
              class="bg-transparent"
              style="font-family: Oxanium"
            >
              <div
                v-if="timer && timer != 'Leaderboard ended'"
                class="flex flex-row md:gap-x-2"
              >
                <div class="relative h-[84px] w-[84px] md:h-[100px] md:w-[100px]">
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:w-[100px] md:h-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{
                        timer.split(" ")[0].substring(0, timer.split(" ")[0].length - 1)
                      }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#F25960]">
                      DAYS
                    </h6>
                  </div>
                </div>

                <div class="relative h-[84px] w-[84px] md:h-[100px] md:w-[100px]">
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{
                        timer.split(" ")[1].substring(0, timer.split(" ")[1].length - 1)
                      }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#F25960]">
                      HRS
                    </h6>
                  </div>
                </div>

                <div class="relative h-[84px] w-[84px] md:h-[100px] md:w-[100px]">
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{
                        timer.split(" ")[2].substring(0, timer.split(" ")[2].length - 1)
                      }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#F25960]">
                      MIN
                    </h6>
                  </div>
                </div>

                <div class="relative h-[84px] w-[84px] md:h-[100px] md:w-[100px]">
                  <img
                    src="@/assets/countdown.png"
                    alt="Timer Background"
                    class="absolute inset-0 object-cover h-[84px] w-[84px] md:h-[100px] md:w-[100px]"
                  />
                  <div class="absolute inset-0 flex flex-col items-center justify-center">
                    <h4
                      class="text-white text-[36px] leading-[46px] font-bold text-center"
                    >
                      {{
                        timer.split(" ")[3].substring(0, timer.split(" ")[3].length - 1)
                      }}
                    </h4>
                    <h6 class="text-sm leading-6 font-bold text-center text-[#F25960]">
                      SEC
                    </h6>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="text-white text-2xl md:text-[36px] md:leading-[48px] font-bold py-[11px]"
              >
                Leaderboard Ended
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col md:flex-row justify-center items-center mb-20 md:mb-[105px]"
        >
          <div class="block">
            <label
              class="toggle-switch md:mt-8 bg-tansparent"
              style="font-family: Lato, sans-serif"
            >
              <input
                type="checkbox"
                @change="changeLeaderboard()"
                v-model="selectedLeaderboard"
              />
              <div class="slider"></div>
              <div
                class="left-label relative py-4 md:py-6 w-[300px] h-[72px] rounded-[10px]"
                :class="selectedLeaderboard === false ? 'text-white' : ''"
              >
                <img
                  :src="activeTabImage"
                  :class="selectedLeaderboard === false ? 'hidden' : ''"
                  class="absolute -top-[12px] right-0 w-full h-[88px] z-10"
                />
                <p
                  class="absolute inset-0 top-[16px] text-center text-lg md:leading-[28px] font-extrabold z-20"
                  :class="selectedLeaderboard === false ? 'text-[#1B1B1B]' : 'text-white'"
                >
                  CURRENT LEADERBOARD
                </p>
              </div>
              <div
                class="right-label relative py-4 md:py-6 w-[300px] h-[52px] md:h-[72px] rounded-[10px]"
                :class="selectedLeaderboard === false ? 'text-white' : ''"
              >
                <img
                  :src="inActiveTabImage"
                  :class="selectedLeaderboard && 'hidden'"
                  class="absolute -top-[12px] right-0 w-[300px] h-[88px] z-10"
                />
                <p
                  class="absolute inset-0 top-[16px] text-center text-lg md:leading-[28px] font-extrabold z-20"
                  :class="selectedLeaderboard === false ? 'text-white' : 'text-[#1B1B1B]'"
                >
                  PREVIOUS LEADERBOARD
                </p>
              </div>
            </label>
          </div>
        </div>
        <div
          v-if="loading == true"
          class="mt-10 text-xl font-bold text-center text-white md:text-4xl"
          style="font-family: Secular One, sans-serif"
        >
          Loading Leaderboard...
        </div>
        <div v-if="loading == false" class="relative w-full mt-24 md:mt-0">
          <div
            class="flex flex-row justify-center items-center mt-44 gap-[34px] md:gap-10 xl:gap-12 md:mb-16 lg:mb-0 lg:mt-16"
          >
            <div
              v-motion-pop-visible
              class="flex flex-col items-center mt-28 h-full md:h-[260px] lg:h-full md:mt-44 lg:mt-[88px] border-t border-b border-solid"
              style="
                box-shadow: -4px -4px 15px 3px rgba(166, 42, 255, 1),
                  4px 4px 15px 3px rgba(242, 89, 96, 0.5);
                border-image: linear-gradient(to left, #ff252f, #a62aff) 1;
              "
            >
              >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] from-[#A62AFF1A] via-[#F2596033] to-[#A62AFF1A] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#FF252F] to-[#A62AFF] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                    style="
                      box-shadow: -4px -4px 15px 2px rgba(166, 42, 255, 1),
                        4px 4px 15px 2px rgba(242, 89, 96, 0.5);
                    "
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#7679D3] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#A369C3] to-[rgba(163,_105,_195,_0)] h-full w-full rounded-full"
                      >
                        <h2
                          class="my-auto font-black text-white text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          2nd
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="text-white lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? maskString(top3[1]?.user_name) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] uppercase mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{ top3.length > 0 ? top3[1]?.wagered : "" }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wagered:
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-12 xl:px-16 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-white font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        ${{ getRewardValue(1) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-motion-pop-visible
              class="absolute flex flex-col items-center border-t border-b border-solid md:h-[260px] lg:h-full lg:-mt-40 top-2 lg:relative"
              style="
                box-shadow: -4px -4px 15px 3px rgba(166, 42, 255, 1),
                  4px 4px 15px 3px rgba(242, 89, 96, 0.5);
                border-image: linear-gradient(to left, #ff252f, #a62aff) 1;
              "
            >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] from-[#A62AFF1A] via-[#F2596033] to-[#A62AFF1A] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#FF252F] to-[#A62AFF] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                    style="
                      box-shadow: -4px -4px 15px 2px rgba(166, 42, 255, 1),
                        4px 4px 15px 2px rgba(242, 89, 96, 0.5);
                    "
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#7679D3] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#A369C3] to-[rgba(163,_105,_195,_0)] h-full w-full rounded-full"
                      >
                        <h2
                          class="my-auto font-black text-white text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          1st
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="text-white lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? maskString(top3[0]?.user_name) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] uppercase mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{ top3.length > 0 ? top3[0]?.wagered : "" }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wagered:
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-2 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-white font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        ${{ getRewardValue(0) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-motion-pop-visible
              class="flex flex-col items-center mt-28 md:h-[260px] lg:h-full md:mt-44 lg:mt-[88px] border-t border-b border-solid"
              style="
                box-shadow: -4px -4px 15px 2px rgba(166, 42, 255, 1),
                  4px 4px 15px 2px rgba(242, 89, 96, 0.5);
                border-image: linear-gradient(to left, #ff252f, #a62aff) 1;
              "
            >
              >
              <div
                class="p-2.5 pb-[13px] md:pb-1 bg-gradient-to-r rounded-none w-[150px] md:w-[200px] lg:w-[280px] xl:w-[325px] from-[#A62AFF1A] via-[#F2596033] to-[#A62AFF1A] bg-opacity-5"
              >
                <div
                  class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                >
                  <div
                    class="bg-gradient-to-tl w-[70px] lg:w-[146px] from-[#FF252F] to-[#A62AFF] -mt-[78px] lg:-mt-[120px] -ml-10 h-[70px] lg:h-[146px] rounded-full overflow-hidden top-0 translate-x-4"
                    style="
                      box-shadow: -4px -4px 15px 2px rgba(166, 42, 255, 1),
                        4px 4px 15px 2px rgba(242, 89, 96, 0.5);
                    "
                  >
                    <div
                      class="absolute inset-0 m-[2px] bg-[#7679D3] flex items-center justify-center overflow-hidden rounded-full"
                    >
                      <div
                        class="bg-gradient-to-t flex justify-center from-[#A369C3] to-[rgba(163,_105,_195,_0)] h-full w-full rounded-full"
                      >
                        <h2
                          class="my-auto font-black text-white text-center text-[32px] leading-[38px] lg:text-[48px] lg:leading-[58px]"
                          style="font-family: Lato, sans-serif"
                        >
                          3rd
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center w-full mt-4 lg:mt-9"
                  >
                    <p
                      class="text-white lg:text-base text-sm font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Russo One, system-ui"
                    >
                      {{ top3.length > 0 ? maskString(top3[2]?.user_name) : "" }}
                    </p>
                    <p
                      class="text-white text-lg lg:text-[32px] lg:leading-[38px] uppercase mt-3 lg:mt-8 font-bold overflow-hidden max-w-[130px] md:max-w-full text-ellipsis whitespace-nowrap"
                      style="font-family: Lato, sans-serif"
                    >
                      {{ top3.length > 0 ? top3[2]?.wagered : "" }}
                    </p>
                    <p
                      class="mt-1 text-sm font-bold text-white uppercase lg:text-base"
                      style="font-family: Lato, sans-serif"
                    >
                      Wagered:
                    </p>
                    <div
                      class="mt-[29px] lg:mt-[43px] relative px-[26px] py-1 lg:py-2 lg:px-12 xl:px-16 w-full"
                    >
                      <img
                        src="../assets/prize-button.png"
                        class="absolute top-0 left-0 w-full h-[43px] md:h-[72px]"
                        alt="Reward"
                      />
                      <p
                        class="text-white font-black text-2xl md:mt-4 lg:mt-0 lg:text-[48px] lg:leading-[58px] text-center"
                        style="font-family: Lato, sans-serif"
                      >
                        ${{ getRewardValue(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex justify-center mt-8 lg:mt-[91px] mb:mb-24 bg-transparent mx-auto max-w-[1280px] px-6 md:px-14"
            style="
              border-image-source: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0.1),
                rgba(242, 89, 96, 0.2),
                rgba(255, 255, 255, 0.1)
              );
              border-image-slice: 1;
            "
          >
            <table
              class="w-full h-[1000px] lg:w-full bg-gradient-to-r from-[#A62AFF1A] via-[#F2596033] to-[#A62AFF1A] bg-opacity-5"
              style="
                box-shadow: -4px -4px 15px 0px rgba(166, 42, 255, 1),
                  4px 4px 15px 0px rgba(242, 89, 96, 0.5);
              "
            >
              <thead
                v-motion-slide-visible-bottom
                class="bg-transparent"
                style="font-family: Lato, sans-serif"
              >
                <tr>
                  <th
                    class="text-center px-5 lg:px-[45px] xl:pr-28 xl:pl-12 py-2 md:py-4 text-white text-[18px] leading-6 font-black md:text-left rounded-l w-1/4"
                  >
                    RANK
                  </th>
                  <th
                    class="px-1 md:px-5 lg:px-[45px] xl:px-24 py-2 md:py-4 text-white text-[18px] leading-6 font-black text-center w-1/4"
                  >
                    USER
                  </th>
                  <th
                    class="px-0 md:px-5 lg:px-[45px] xl:px-24 py-2 md:py-4 text-white text-[18px] leading-6 font-black text-center w-1/4"
                  >
                    WAGERED
                  </th>
                  <th
                    class="px-4 text-right lg:px-[45px] xl:pl-28 xl:pr-12 py-2 md:py-4 text-white text-[18px] leading-6 font-black rounded-r w-1/4"
                  >
                    PRIZE
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-motion-slide-visible-bottom
                  v-for="(item, index) in topRest"
                  :key="index"
                  style="font-family: Lato, sans-serif"
                  class="bg-transparent rounded"
                >
                  <td
                    class="px-5 text-center lg:px-[45px] xl:px-28 xl:pl-12 py-2 md:py-4 whitespace-nowrap text-base font-normal md:text-left uppercase w-1/4"
                  >
                    <div class="text-white tracking-[4px]">
                      {{ getOrdinalSuffix(index + 4) }}
                    </div>
                  </td>
                  <td
                    class="px-2 md:px-5 max-w-[92px] overflow-hidden text-ellipsis md:max-w-full py-2 md:py-5 whitespace-nowrap text-base text-white font-normal text-center tracking-[4px] w-1/4"
                  >
                    {{ maskString(item?.user_name) }}
                  </td>
                  <td
                    class="px-1 md:px-5 max-w-[92px] py-2 md:py-5 whitespace-nowrap text-ellipsis overflow-hidden text-base text-white font-normal text-center tracking-[4px] w-1/4"
                  >
                    {{ item?.wagered }}
                  </td>
                  <td
                    class="px-4 text-center md:px-5 lg:px-[45px] xl:px-28 xl:pr-12 py-2 md:py-5 whitespace-nowrap text-base text-white font-black md:text-right tracking-[4px] w-1/4"
                  >
                    ${{ getRewardValue(index + 3) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Awareness/Notification Box -->
          <div
            v-motion-pop-visible
            class="mt-16 max-w-[1280px] mx-auto px-6 md:px-14 py-6 rounded-2xl bg-[#1E1E2F]/50 border border-[#F25960] shadow-xl text-white text-left space-y-4"
            style="font-family: Lato, sans-serif"
          >
            <h2
              class="text-xl md:text-2xl text-center sm:text-start font-extrabold text-[#F25960]"
            >
              🔥 Hanvee's Exclusive Wager Race <span class="block sm:inline text-lg sm:text-xl font-bold text-white mt-1 sm:mt-0">- 20 Places ($10k) - Started 12 Days Ago</span> 🔥
            </h2>
            <p class="text-white/90 text-sm md:text-base">
              💥 <span class="font-semibold">Total Prize Pool:</span> ${{
                animatedTotalPrize.toLocaleString()
              }}
              💥
            </p>
            <div class="ml-2 sm:ml-6 space-y-2 text-white/80 text-sm md:text-base">
               <p class="font-bold text-white text-lg mb-2">Rules:</p>
               <ul class="space-y-3">
                 <li class="flex items-start">
                   <span class="mr-2 text-xl">➡️</span>
                   <span>
                     Monthly Leaderboard available for Stake accounts registered under codes:
                     <span class="font-extrabold text-[#F25960]">hanvee</span> &amp;
                     <span class="font-extrabold text-[#F25960]">hanvee200</span>
                   </span>
                 </li>
                 <li class="flex items-start">
                   <span class="mr-2 text-xl">➡️</span>
                   <span>
                     Weekly cashback (separated from Stake's official weekly) paid every Thursday via Tip on Stake
                   </span>
                 </li>
                 <li class="flex items-start">
                   <span class="mr-2 text-xl">➡️</span>
                   <span>
                     ONLY ON STAKE GAMES ARE BEING COUNTED TOWARD THE LEADERBOARD (
                     <a
                       href="https://stake.com/casino/group/only-on-stake"
                       target="_blank"
                       class="underline hover:text-[#F25960] transition-colors"
                       >https://stake.com/casino/group/only-on-stake</a
                     >
                     )
                   </span>
                 </li>
                 <li class="flex items-start">
                   <span class="mr-2 text-xl">➡️</span>
                   <span>
                     Wager abuse will result in removal from the leaderboard and forfeiture of any prizes. Play fair and enjoy the competition!
                   </span>
                 </li>
               </ul>
            </div>
            <p class="pt-2 text-white/90 text-center sm:text-start text-sm md:text-base">
              🔥 Whether you're spinning for fun or going full grind, now’s the time to
              level up. Start wagering and race to the top!
            </p>
            <p class="text-[#96FF82] text-center sm:text-start font-semibold">
              🎥 Watch my stream:
              <a href="https://kick.com/hanvee" class="underline hover:text-white"
                >kick.com/hanvee</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- <PrevLeaderboardSection ref="PrevLeaderboardSection"/> -->
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

export default {
  name: "LeaderboardSection",
  data() {
    return {
      top3: [],
      topRest: [],
      timer: "",
      topForMobile: [],
      selectedLeaderboard: false,
      activeTabImage: require("../assets/tab-active.png"),
      inActiveTabImage: require("../assets/tab-inactive.png"),
      currentLeaderboard: [],
      prevLeaderboard: [],
      animatedTotalPrize: 0,
      startDate: null,
      endDate: null,
      notFormattedEndDate: null,
      loading: false,
    };
  },
  computed: {
    currentPrizeTitle() {
      return `$${this.animatedTotalPrize.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
  },
  watch: {
    selectedLeaderboard(newSelected) {
      if (newSelected) {
        this.activeTabImage = require("../assets/tab-inactive.png");
        this.inActiveTabImage = require("../assets/tab-active.png");
      } else {
        this.activeTabImage = require("../assets/tab-active.png");
        this.inActiveTabImage = require("../assets/tab-inactive.png");
      }
      this.animateValues();
    },
  },
  methods: {
    async init() {
      const baseUrl = process.env.VUE_APP_BASE_API;
      this.loading = true;
      await axios
        .get(`${baseUrl}/api/leaderboard/only-on-stake`, {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
          },
        })
        .then((res) => {
          axios
            .get(`${baseUrl}/api/leaderboard/only-on-stake?previous=true`, {
              headers: {
                "x-api-key": process.env.VUE_APP_X_API_KEY,
              },
            })
            .then((rest) => {
              this.startDate = moment(res.data.startDate).format("MMMM DD, YYYY");
              this.endDate = moment(res.data.endDate).format("MMMM DD, YYYY");
              this.notFormattedEndDate = res.data.endDate;
              this.currentLeaderboard = res.data.leaderboard;
              this.prevLeaderboard = rest.data.leaderboard;
              this.changeLeaderboard();
              this.startTimer();
              this.animateValues(); // call after data is fetched
              this.loading = false;
            });
        });
    },
    changeLeaderboard() {
      const leaderboard = (this.selectedLeaderboard
        ? this.prevLeaderboard
        : this.currentLeaderboard) || [];

      this.top3 = leaderboard.slice(0, 3);
      this.topRest = leaderboard.slice(3, 20);
      this.topForMobile = leaderboard.slice(0, 20);
    },
    maskString(str) {
      if (!str || str.length <= 2) return str;
      const first = str[0];
      const last = str[str.length - 1];
      const masked = "*".repeat(str.length - 2);
      return `${first}${masked}${last}`;
    },
    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    getRewardValue(rank) {
      const currentPrizes = (process.env.VUE_APP_STAKE_CURRENT_LEADERBOARD_REWARDS || "")
        .replaceAll("[", "")
        .replaceAll("]", "")
        .replaceAll(" ", "")
        .split(",")
        .map(Number)
        .filter((n) => !isNaN(n));

      const previousPrizes = (process.env.VUE_APP_STAKE_PREVIOUS_LEADERBOARD_REWARDS || "")
        .replaceAll("[", "")
        .replaceAll("]", "")
        .replaceAll(" ", "")
        .split(",")
        .map(Number)
        .filter((n) => !isNaN(n));

      const prizes = this.selectedLeaderboard ? previousPrizes : currentPrizes;

      if (prizes && rank >= 0 && rank < prizes.length && !isNaN(prizes[rank])) {
        return prizes[rank].toLocaleString();
      }

      return "0";
    },
    startTimer() {
      const getNextTargetDate = () => {
        return moment(this.notFormattedEndDate).utc();
      };

      let targetDate = getNextTargetDate();
      let timerInterval;

      const updateTimer = () => {
        const nowUtc = moment.utc();
        const distance = targetDate.diff(nowUtc);

        if (distance >= 0) {
          const duration = moment.duration(distance);
          const days = Math.floor(duration.asDays());
          const hours = duration.hours();
          const minutes = duration.minutes();
          const seconds = duration.seconds();

          this.timer = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else {
          this.timer = "Leaderboard ended";
          clearInterval(timerInterval);
        }
      };

      updateTimer();
      timerInterval = setInterval(updateTimer, 1000);
    },
    animateValues() {
      const rewardsStr = this.selectedLeaderboard
        ? process.env.VUE_APP_STAKE_PREVIOUS_LEADERBOARD_REWARDS
        : process.env.VUE_APP_STAKE_CURRENT_LEADERBOARD_REWARDS;

      const rewards =
        (rewardsStr || "")
          .replaceAll("[", "")
          .replaceAll("]", "")
          .replaceAll(" ", "")
          .split(",")
          .map(Number)
          .filter((n) => !isNaN(n));

      const totalPrize = rewards.reduce((sum, val) => sum + val, 0);
      this.animateNumber("animatedTotalPrize", totalPrize);
    },
    animateNumber(variable, targetValue) {
      let startValue = this[variable] || 0;
      if (startValue === targetValue) return;

      const step = Math.max(1, Math.abs(targetValue - startValue) / 20);
      const isNegative = startValue > targetValue;

      const interval = setInterval(() => {
        if (isNegative) {
          startValue -= step;
          if (startValue <= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        } else {
          startValue += step;
          if (startValue >= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        }

        this.$nextTick(() => {
          this[variable] = parseFloat(startValue.toFixed(2));
        });
      }, 50);
    },
    isMobile() {
      return window?.innerWidth < 768;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 632px;
  height: 72px;
  border: 2px #2cceee;
  border-radius: 20px;
  padding: 0 8px;
  cursor: pointer;

  @media screen and (max-width: 640px) {
    width: 300px;
    height: 74px;
  }
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch .slider {
  position: absolute;
  left: 2px;
  top: 2px;
  border-radius: 30px;
  width: 300px;
  height: 68px;
  background: white;
  box-shadow: inset 8px -6px 15.4px 3px rgba(68, 50, 81, 0.5),
    0 0 20px 1px rgba(255, 37, 47, 0.2), 0 0 20px 4px rgba(166, 42, 255, 0.2);
  transition: transform 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;
}

/* Transition for desktop - horizontal movement */
@media screen and (min-width: 641px) {
  .toggle-switch input:checked + .slider {
    transform: translateX(330px); /* Horizontal movement */
  }
}

/* Transition for mobile - vertical movement */
@media screen and (max-width: 640px) {
  .toggle-switch input:checked + .slider {
    transform: translateY(96px); /* Vertical movement on mobile */
  }
}

.toggle-switch span {
  font-size: 35px;
  font-weight: bold;
  z-index: 1;
  padding: 0 8px;
}

.toggle-switch .left-label {
  position: absolute;
  left: 0px;
  margin-top: 5px;
  font-weight: 50;

  @media screen and (max-width: 640px) {
    top: 0px;
  }
}

.toggle-switch .right-label {
  position: absolute;
  right: 2px;
  margin-top: 5px;
  font-weight: 50;

  @media screen and (max-width: 640px) {
    bottom: -80px;
  }
}

.custom-border {
  opacity: 1;
  margin: 10px;
  border: solid 2px transparent;
  border-radius: 10px;
  background-image: linear-gradient(#090b2a, #090b2a),
    linear-gradient(to bottom, #ed3c80, #3e6b3e);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}
</style>
